import { listMessageRecipientsService, sendMessageService } from "../services/messages";

export const messages = {
    state: {
        recipients: [],
        recipientsTotal: 0,
        recipientsLimit: 0,
        sendMessageResponse: {},
    },

    reducers: {
        listMessageRecipients: (state, data) => {
            return {
                ...state,
                recipients: data,
                recipientsTotal: data?.totalcount,
                recipientsLimit: data?.limit,
            };
        },
        sendMessageResponseData: (state, data) => {
            return {
                ...state,
                sendMessageResponse: data,
            };
        },
    },

    effects: () => ({
        async listMessageRecipientsData(data) {
            try {
                const responseData = await listMessageRecipientsService(data);
                this.listMessageRecipients(responseData.data);
                return responseData?.data;
            } catch (err) {
                console.log("err", err);
                throw err;
            }
        },

        async sendMessage(data) {
            try {
                const responseData = await sendMessageService(data);
                this.sendMessageResponseData(responseData.data);
                return responseData?.data;
            } catch (err) {
                console.log("err", err);
                throw err;
            }
        },
    }),
};
